import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { FileSpreadsheet, FileText } from 'lucide-react';

// Import the existing page components
import AdminImportPage from './AdminImportPage';
import AdminFormsPage from './AdminFormsPage';
import AdminPDFFormsPage from './AdminPDFFormsPage';

export default function AdminToolsPage() {
  const [activeTab, setActiveTab] = useState('import');

  return (
    <div className="space-y-6" data-testid="admin-tools-page">
      <div>
        <h1 className="font-heading text-2xl font-bold">Tools</h1>
        <p className="text-muted-foreground">Import data and manage forms</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto lg:inline-flex">
          <TabsTrigger value="import" className="flex items-center gap-2">
            <FileSpreadsheet className="h-4 w-4" />
            <span className="hidden sm:inline">Import</span>
          </TabsTrigger>
          <TabsTrigger value="forms" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            <span className="hidden sm:inline">Forms</span>
          </TabsTrigger>
          <TabsTrigger value="pdf-forms" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            <span className="hidden sm:inline">PDF Forms</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="import" className="mt-6">
          <AdminImportPage embedded />
        </TabsContent>
        <TabsContent value="forms" className="mt-6">
          <AdminFormsPage embedded />
        </TabsContent>
        <TabsContent value="pdf-forms" className="mt-6">
          <AdminPDFFormsPage embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
